module.exports = {
  parse: {
    prelude: null,
    block: function block() {
      return this.Block(true);
    }
  }
};